export const extensionRoutes = [];
